type V2VerificationEnvelope = {
  success?: unknown;
  loggedIn?: unknown;
  verified?: unknown;
  creds?: unknown;
};

export function normalizeV2Verified(response: V2VerificationEnvelope): boolean {
  if (response.verified !== undefined) return response.verified === true;
  if (response.success !== true || response.loggedIn !== true) return false;
  if (!response.creds || typeof response.creds !== 'object') return false;
  return (response.creds as Record<string, unknown>).verified === true;
}
